"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabsWrapper = exports.TabItem = exports.MobileTabsWrapper = exports.MobileTab = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const TabsWrapper = _styledComponents.default.div`
  z-index: 15;
  position: relative;

  display: flex;
  width: 100%;
  padding-top: 48px;
  margin-top: -48px;

  @media (max-width: 991px) {
    padding-top: 48px;
    min-height: 90px !important;
    height: 90px !important;
    max-height: 90px !important;
  }

  @media (min-width: 992px) {
    padding-top: 0px;
    margin-top: 0px;
  }
`;
exports.TabsWrapper = TabsWrapper;
const MobileTab = _styledComponents.default.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  font-family: 'univers-black', sans-serif;
  font-size: 12px;
  padding: 12px 30px;
  color: white;
  text-align: center;
  position: relative;
  background: black;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  border: none;
  outline: none;
  user-select: none;
  flex-basis: 0;
  flex-grow: 1;

  border-bottom: 2px solid
    ${props => props.selected ? 'white' : 'transparent'};

  span {
    white-space: nowrap;
  }
`;
exports.MobileTab = MobileTab;
const MobileTabsWrapper = _styledComponents.default.div`
  max-width: 100%;
  width: 100%;
`;
exports.MobileTabsWrapper = MobileTabsWrapper;
const TabItem = _styledComponents.default.button`
  flex-basis: 0;
  flex-grow: 1;
  font-family: 'univers-black', sans-serif;
  padding: 12px 12px;
  color: white;
  position: relative;
  height: 42px;
  background: black;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  border: none;
  outline: none;
  cursor: pointer;

  &:after {
    content: '';
    position: absolute;
    bottom: -0.5px;
    left: 0;
    width: 100%;
    height: 3px;
    background: ${props => {
  return props.isActive ? 'white' : 'transparent';
}};
  }

  &:hover {
  }

  @media (max-width: 767px) {
    font-size: 12px;
  }
`;
exports.TabItem = TabItem;
//# sourceMappingURL=styles.js.map